import classNames from 'classnames';

function Container({ children, className, ...props }) {
  return (
    <div
      {...props}
      className={classNames({
        [className]: true,
        ' w-full pt-12 pb-10 items-left': true,
      })}
    >
      {children}
    </div>

  );
}

export default Container;
